import useSWR from 'swr';
import { useBrandId } from 'AppProvider';
import fetchRescheduleSessions from './fetchRescheduleSessions';
import buildRescheduleSessionsUrl from './buildRescheduleSessionsUrl';

const fetchRescheduleSessionsSWR = async ([url, { brandId }]: [
  string,
  { brandId: string },
]) => fetchRescheduleSessions(url, { brandId });

const useRescheduleSessions = (
  bookingId: string,
  {
    from,
    to,
    skip = false,
    resourceGroupId,
  }: {
    from: string | undefined;
    to: string | undefined;
    skip?: boolean;
    resourceGroupId?: string;
  },
) => {
  const brandId = useBrandId();
  const url = skip
    ? null
    : buildRescheduleSessionsUrl(bookingId, {
        from,
        to,
        resourceGroupId,
      });

  const swr = useSWR(
    url ? [url, { brandId }] : null,
    fetchRescheduleSessionsSWR,
  );

  return swr;
};

export default useRescheduleSessions;
